module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_bwh-3c618e010e81123458c6c7b792fcad5b.png";